import { adminRole, lightPrimary } from 'src/colors';
import { UserRole, UserRoleTranslations } from 'src/types/enum/user-role';

export const adminsRoleTranslations = {
  [UserRole.MASTER]: UserRoleTranslations.MASTER,
  [UserRole.ADMIN]: UserRoleTranslations.ADMIN,
  [UserRole.VIEWER]: UserRoleTranslations.VIEWER,
  [UserRole.OWNER]: UserRoleTranslations.OWNER,
};

export const adminsRolesColor = {
  [UserRole.MASTER]: lightPrimary.hoverOutlined,
  [UserRole.OWNER]: adminRole.owner,
  [UserRole.ADMIN]: adminRole.admin,
  [UserRole.VIEWER]: adminRole.viewer,
};
